import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable, Injector } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { FeedbackActivityRecorder } from './feedback-activity-recorder.service';

/** EXT-6172: records failed API calls (method, path, status -- never bodies)
 * into the feedback context's ring buffer. Pass-through otherwise.
 *
 * The recorder is resolved lazily: it depends on Router, and a portal's
 * context services depend on AuthService, which uses HttpClient, which
 * constructs this interceptor -- keeping every link lazy avoids a circular
 * dependency whatever a portal wires around it. */
@Injectable()
export class FeedbackErrorInterceptor implements HttpInterceptor {
  private readonly injector = inject(Injector);

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap({
        error: (error: unknown) => {
          if (error instanceof HttpErrorResponse) {
            this.injector
              .get(FeedbackActivityRecorder)
              .recordHttpError(
                request.method,
                request.urlWithParams,
                error.status,
                error.statusText || error.message,
              );
          }
        },
      }),
    );
  }
}
